var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"icon-list no-bullets",attrs:{"slot":"user"},slot:"user"},[_c('li',[_vm._m(0),_vm._v(" "),_c('a',{attrs:{"href":"/"}},[_vm._v(_vm._s(_vm.$t("common.menus.my_profile")))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"width-3 mb-min"},[_c('i',{staticClass:"material-icons"},[_vm._v("perm_identity")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28c843c5","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/menu/MainMenuUser.vue
// module id = HP5D
// module chunks = 0 1